module.exports = __webpack_public_path__ + "img/phone--mobile.b766fe0.jpg";